import { render, staticRenderFns } from "./SetsReceiveNumbers.vue?vue&type=template&id=e22081a4&"
import script from "./SetsReceiveNumbers.vue?vue&type=script&lang=js&"
export * from "./SetsReceiveNumbers.vue?vue&type=script&lang=js&"
import style0 from "./SetsReceiveNumbers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports